// Install-modal control helpers — the marketplace-function subset the unified
// shell references EAGERLY, split out of the heavy `functions/index.js` barrel
// (#16 marketplace half).
//
// `functions/index.js` is a single ~116KB module (catalog hydration, community
// feed, install dispatch, URL sync, …). The shell keeps it OUT of its eager
// chunk by importing `functions/eagerSlice.js` instead — and the eager slice
// `export *`s from THIS light source file, never from `./index.js` (marketplace
// has no `sideEffects: false`, so re-referencing index.js would evaluate the
// whole barrel). Only the genuinely eager-referenced control(s) live here.
//
// `closeInstallModal` is the one marketplace function the eager shell references
// outside a marketplace-mounted component: `app.js`'s shell-root install-modal
// watcher calls `el.call('closeInstallModal', s.root)` in its `onCancel`
// (app.js ~1160). It is also re-exported from `index.js` (single source of
// truth) so the marketplace island / detail / Esc-handler keep resolving it,
// and so the fold's add-missing merge sees the same binding.
// THE EXIT of a display-gated App Store window (white-label redesign, lane
// W2 — DESIGN_SPEC §6.4: the veil fades out on B, the sheet leaves on
// `modalOut`, C defaultBezier). The window must play its exit BEFORE its
// state clears — clearing first empties it mid-fade. So a close:
//   1. flags the exit (`closingKey: true`); the window keys its exit
//      animations on a `data-closing` rule — a close already running is not
//      restarted;
//   2. clears the state after the exit's length. A TIMER, never
//      `animationend`: animation events are frame-gated and never fire in a
//      hidden tab (canvas PageSlot's FRAME-INDEPENDENCE note).
// The finish leaves a REOPENED window alone: an opener writes
// `closingKey: false`, and a window whose content changed during the exit was
// reopened by a writer that knows nothing of the flag. It can never strand a
// window open: a host that drops the flag write still closes — only an
// explicit `false` cancels. Nothing open → the plain clear, as before.
// `after` runs once the state is clear (focus return).
export const marketplaceCloseWithExit = (host, key, closingKey, clearPatch, after) => {
  if (!host) return
  const done = () => {
    host.update?.({ ...clearPatch, [closingKey]: false })
    if (typeof after === 'function') after()
  }
  if (!host[key]) return done()
  if (host[closingKey] === true) return
  const read = () => {
    try {
      return JSON.stringify(host[key])
    } catch (_) {
      return ''
    }
  }
  const snapshot = read()
  host.update?.({ [closingKey]: true })
  // The exit's length: the sheet's C (≈266ms) and a frame of slack.
  setTimeout(() => {
    if (host[closingKey] === false) return
    if (read() !== snapshot) return host.update?.({ [closingKey]: false })
    done()
  }, 280)
}

export const closeInstallModal = (host) =>
  marketplaceCloseWithExit(host, 'installModal', '_installModalClosing', {
    installModal: null,
    _installModalSaving: false,
    _installModalError: null,
    _scopeWsQuery: '',
    _scopeProjQuery: ''
  })
